import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class BehaviorRegistry {
  private _registeredBehaviors = new Map<string, () => Promise<any>>();

  constructor() {}

  registerBehavior(key, fn: () => Promise<any>) {
    this._registeredBehaviors.set(key, fn);
  }
  has(key) {
    return this._registeredBehaviors.has(key);
  }
  get(key) {
    return this._registeredBehaviors.get(key);
  }
}
